import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "hideEmptyDate",
  pure: false,
  standalone: true,
})
export class HideEmptyDatePipe implements PipeTransform {
  private lastValue: string | null = null;
  private lastResult = false;

  transform(value: string | null | undefined): boolean {
    if (value === this.lastValue) {
      return this.lastResult;
    }

    this.lastValue = value ?? null;
    this.lastResult = Boolean(value && !value.includes("0001"));

    return this.lastResult;
  }
}
